import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Hero = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="relative bg-gradient-to-br from-indigo-700 via-violet-800 to-purple-900 text-white py-20 md:py-32 overflow-hidden">
      {/* Decorative glow */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-fuchsia-500/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-indigo-400/20 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block mb-6 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-sm font-semibold tracking-wide uppercase text-indigo-100">
            {t.hero.eyebrow}
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            {t.hero.title}
          </h1>
          <p className="text-xl md:text-2xl mb-6 text-indigo-100 font-medium">
            {t.hero.subtitle}
          </p>
          <p className="text-lg md:text-xl mb-6 text-indigo-200 max-w-3xl mx-auto leading-relaxed">
            {t.hero.description}
          </p>
          <p className="text-base md:text-lg mb-10 text-indigo-300 max-w-2xl mx-auto leading-relaxed italic">
            {t.hero.note}
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <a
              href="/s"
              className="bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              {t.hero.cta}
            </a>
            <a
              href="#how"
              className="border-2 border-white/40 hover:border-white text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 hover:bg-white/10"
            >
              {t.hero.secondaryCta}
            </a>
          </div>
          <div className="mt-8 text-sm text-indigo-200 font-mono tracking-wide">
            {t.hero.badge}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
